import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import { Modal } from 'antd';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';
import { Button } from '@/shared/uikit/Button';
import { Title } from '@/shared/uikit/Title';

import { useModalsStore } from '../../modals.store';
import { DeletePrivateDocumentConfirmProps } from '../../types';

// TODO Delete confirm
export const DeletePrivateDocumentConfirm: FC<DeletePrivateDocumentConfirmProps> = ({
  count,
  onConfirm,
}) => {
  const { t } = useTranslation('widgets/modals', { keyPrefix: 'deletePrivateDocumentsConfirm' });
  const modals = useModalsStore();

  const actions = [
    <Button style={{ height: 44 }} type="default" onClick={modals.closeModal} key="cancel">
      {t('btnCancel')}
    </Button>,
    <Button
      style={{
        height: 44,
        background: COLORS.systemFlame200,
        color: COLORS.systemLight100,
        fontSize: 14,
      }}
      type="primary"
      onClick={() => {
        modals.closeModal();
        onConfirm();
      }}
      key="confirm"
    >
      {t('btnConfirm', { count })}
    </Button>,
  ];

  return (
    <StyledModal
      width={600}
      wrapClassName="my-custom-modal"
      title={<Title style={{ fontSize: 22 }}>{t('title')}</Title>}
      footer={actions}
      onClose={modals.closeModal}
      onCancel={modals.closeModal}
      open
    />
  );
};

const StyledModal = styled(Modal)`
  .my-custom-modal .ant-modal-content {
    padding-inline: 0 !important;
    background: red !important;
  }
`;
